export default __webpack_public_path__ + "../staticImages/wsh_rabatt_rot-260.png";